import { Flex, Link, Spinner, Text } from "@chakra-ui/react";
import ChangePasswordCard from "@/features/my-account/change-password-card";
import UserCard from "@/features/my-account/user-card";
import BusinessInfoCard from "@/features/my-account/business-info-card";
import AlertCard from "@/features/my-account/alert-card";
import ShippingInfoCard from "@/features/my-account/shipping-info-card";
import BoutiqueBusinessInfoCard from "@/features/my-account/boutique-business-info-card";
import BoutiqueBankInfoCard from "@/features/my-account/boutique-bank-info-card";
import { Suspense, useMemo } from "react";
import useIdentity from "@/features/ui/hooks/use-identity";

export default function BuyerMyAccountPage() {
  const identity = useIdentity();
  const company = useMemo(() => {
    return identity?.company;
  }, [identity]);
  return (
    <Flex
      // 좌우 25%를 빼면 콘텐츠 컬럼이 뷰포트 폭의 절반이 된다. 모바일에서는 그 절반이
      // 200px 아래로 붕괴해 카드 안 고정폭 요소가 밖으로 넘치므로 고정 여백으로 바꾼다.
      // md 이상은 기존 25%를 그대로 둬 데스크탑 렌더는 변하지 않는다.
      paddingY={{ base: "16px", md: "24px" }}
      paddingX={{ base: "16px", md: "25%" }}
      flexDirection={"column"}
      gap={"16px"}
      fontSize={"12px"}
      alignItems={"center"}
      overflowY={"auto"}
      height={"100%"}
    >
      <UserCard />
      {company?.type === "BUYER" && <BusinessInfoCard />}
      {company?.type === "BUYER" && <ShippingInfoCard />}
      {company?.type === "BOUTIQUE" && <BoutiqueBusinessInfoCard />}
      {company?.type === "BOUTIQUE" && <BoutiqueBankInfoCard />}
      <ChangePasswordCard />
      {
        company?.type === "BUYER" &&
        <Suspense fallback={<Spinner />}>
          <AlertCard />
        </Suspense>
      }
      <Flex
        padding={"16px 24px"}
        background={"#363636"}
        borderRadius={"8px"}
        gap={"10px"}
        width={"100%"}
        fontSize={"10px"}
        color={"#FFFFFF"}
        flexDirection={"column"}
        opacity={0.6}
      >
        <Flex
          columnGap={"20px"}
          rowGap={"4px"}
          flexWrap={"wrap"}
          textDecoration={"underline"}
        >
          <Link
            href={
              "https://terms.pathrade.com/files/ko/UNOTradingCorp-Pathrade-Privacy-Policy-v1.1-20240111.pdf"
            }
            isExternal={true}
          >
            개인정보 처리방침
          </Link>
          <Link
            href={
              "https://terms.pathrade.com/files/ko/UNOTradingCorp-Pathrade-Service-Agreement-v1.0-20231208.pdf"
            }
            isExternal={true}
          >
            이용약관
          </Link>
        </Flex>
        {/* 주소·이메일·사업자번호를 한 줄에 두면 모바일 폭을 넘겨 오른쪽이 잘린다. */}
        <Flex columnGap={"20px"} rowGap={"4px"} flexWrap={"wrap"}>
          <Text>서울 강남구 강남대로 464, 비제바노 5층</Text>
          <Flex gap={"8px"}>
            <Text>고객 지원 이메일</Text>
            <Text>support@unotrading.co.kr</Text>
          </Flex>
          <Flex gap={"8px"}>
            <Text>사업자 등록번호</Text>
            <Text>750-87-01065</Text>
          </Flex>
        </Flex>
        <Flex>
          <Text>© 2023. UNO Trading Corp. All rights reserved.</Text>
        </Flex>
      </Flex>
    </Flex>
  );
}
